<template>
  <ProgressHeader
    :tabs="tabs"
    :saving-for-exit="savingForExit"
    :disable="disableHeader"
    :disable-save-and-close="disableSaveAndClose"
    @tab:selected="tabSelected"
    @exit="exit"
    @exit:save="saveAndClose"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { getEnv } from 'ecx.saigon.ui.common';
import getValidRote from '@/utils/get-valid-route';
import getUserFeatures from '@/utils/user-features';

export default {
  name: 'ProgressHeaderWidget',
  data() {
    return {
      currentRoute: {},
      creditCheckRoute: undefined,
      coreRoute: undefined
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.currentRoute = this.$router.currentRoute;
      }
    }
  },
  computed: {
    ...mapState({
      application: (state) => state.application.application || {},
      disableNavigation: (state) => state.ui.disableNavigation,
      savingForExit: (state) => state.application.savingForExit,
      loadingQuote: (state) => state.quote.loadingQuote,
      loadingUser: (state) => state.user.loadingUser,
      applicationLoading: (state) => state.lead.applicationLoading
    }),
    ...mapGetters('application', ['isQuoteAccepted', 'isCreditCheckCompleted']),
    userFeatures() {
      return getUserFeatures();
    },
    disableSaveAndClose() {
      return !this.$Constants.ROUTES_REQUIRING_COMPLETED_FORMS[
        this.currentRoute.name
      ];
    },
    disableHeader() {
      return (
        this.loadingQuote ||
        this.loadingUser ||
        this.applicationLoading ||
        this.disableNavigation ||
        this.savingForExit
      );
    },
    tabs() {
      return [
        {
          active: this.currentRouteIsInList(this.$Constants.FINANCE_ROUTES),
          disable: this.disableNavigation,
          label: 'Car Finance',
          icon: 'icon-nav-step-1',
          checked: true,
          to: { name: this.$RouteNames.calculator }
        },
        {
          active: this.currentRouteIsInList(
            this.$Constants.CAR_SELECTION_ROUTES
          ),
          disable: !this.application.applicationId || this.disableNavigation,
          label: 'Car Selection',
          icon: 'icon-nav-step-2',
          iconSize: '20px',
          checked: this.isQuoteAccepted,
          to: { name: this.$RouteNames.summary }
        },
        {
          disable: !this.isQuoteAccepted || this.disableNavigation,
          label: 'Finance Application',
          icon: 'icon-nav-step-3',
          checked: this.currentRouteIsInList(this.$Constants.HR_ROUTES),
          to: this.creditCheckRoute
        },
        {
          active: this.currentRouteIsInList(this.$Constants.HR_ROUTES),
          disable: !this.isCreditCheckCompleted || this.disableNavigation,
          label: 'Employer Approval',
          icon: 'icon-nav-step-4',
          to: { name: this.$RouteNames.hrApprovalSent }
        }
      ];
    }
  },
  methods: {
    ...mapActions('application', ['saveAndExitApplication']),
    exit() {
      this.SAIDialog({
        body: 'Any unsaved changes will be lost.',
        okText: 'Ok',
        cancelText: 'Cancel',
        onOk: () => (window.location = this.coreRoute)
      });
    },
    saveAndClose() {
      this.saveAndExitApplication(this.currentRoute.name);
    },
    tabSelected(tab) {
      // If to is a string, its not going to be an internal route change and should not be validated
      if (typeof tab.to === 'string') {
        return (window.location = tab.to);
      }

      let route = getValidRote(tab.to.name);
      if (route !== this.$router.currentRoute.name) {
        this.$router.push({
          name: route,
          params: { ...this.currentRoute.params }
        });
      }
    },
    currentRouteIsInList(list) {
      return list.includes(this.currentRoute.name);
    }
  },
  async beforeMount() {
    const env = await getEnv();
    this.creditCheckRoute = env.VUE_APP_CREDIT_CHECK_ROUTE;
    this.coreRoute = env.VUE_APP_CORE_ROUTE;
  },
  components: {
    ProgressHeader: () => import('../../components/organism/progress-header')
  }
};
</script>
